var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.obj)?_c('image',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"x":_vm.obj.x,"y":_vm.obj.y,"width":_vm.obj.w,"height":_vm.obj.h,"src":_vm.path + _vm.src,"xlink:href":_vm.path + _vm.src,"title":_vm.title},on:{"click":_vm.onClick,"error":_vm.onError}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }